/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : vlcConfig.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { appColor, componentStyle } from "../../../../config/appTheme";

export const vlcAppTheme = {
  lightBackgroudColor: "#ffffff",
  darkBackgroudColor: "#000000",
  vlcCardHeadingColor: appColor.darkBackgroudColor,
  vlcCardHeadingPrimaryColor: "#ffffff",
  vlcCardFontHeadingColor: "#ffffff",
};

export const vlcCardStyles = {
  vlcHeadingFontSize: "14px",
  vlcCardListColor: "53565A",
  vclCardHeadingSearchbarStyle: {
    "& .MuiOutlinedInput-root": {
      height: "36px", // ✅ overall TextField height
      "& fieldset": { borderColor: "#97999b", borderRadius: "0px" }, // Default
      "&:hover fieldset": { borderColor: "#97999b" }, // Hover
      "&.Mui-focused fieldset": { borderColor: "#ffffff" }, // Focused
      "&.Mui-disabled fieldset": { borderColor: "#53565A" }, // Disabled
      "&.Mui-error fieldset": { borderColor: "#e53935" }, // Error

      // 🔹 Change text color on hover
      "&:hover .MuiInputBase-input::placeholder": {
        color: "#97999b",
      },

      // 🔹 Change text color on focus (selected)
      "&.Mui-focused .MuiInputBase-input::placeholder": {
        color: "#ffffff",
      },
    },

    "& .MuiInputLabel-root": {
      color: "#ffffff",
      fontSize: "0.9rem",
      "&.Mui-error": { color: "#e53935" },
      "&.Mui-disabled": { color: "#53565A" },
    },

    "& .MuiInputBase-input": {
      color: "#ffffff", // typed text color
      height: "100%", // ✅ fill available height
      boxSizing: "border-box",
      padding: "8px 12px", // ✅ balance text vertically inside 36px
    },

    "& .MuiInputBase-input::placeholder": {
      color: "#ffffff",
      opacity: 1,
    },

    "& .MuiInputAdornment-root": {
      color: "#ffffff",
    },

    "& .MuiFormHelperText-root.Mui-error": {
      color: "#e53935",
      fontSize: "0.8rem",
      marginLeft: 0,
      marginTop: "4px",
    },
  },
};

export const vlcComponentStyle = {
  card: {
    mb: 1.5,
    p: 0,
    m: 0,
    boxShadow: "none",
    width: "100%",
    borderRadius: "0px",

  },
  cardHeader: {
    backgroundColor: vlcAppTheme.vlcCardHeadingColor,
    color: vlcAppTheme.vlcCardFontHeadingColor,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    p: 1,
  },

  cardContent: {
    p: 0,
    m: 0,
    height: "100%",
    width: "100%",
    overflowY: "auto",
  },
  cardContentBox: {
    p: 0,
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "start",
    boxShadow: "none",
    cursor: "pointer",

    border: "1px solid #ddd",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
    transition: "border 0.2s",
  },

  selectedCardBox: (isSelected) => ({
    backgroundColor: isSelected ? "#f0f0f0" : "#ffffff",
  }),

  carCard: {
    zoneMainBox: {},
    zoneText: {
      ...componentStyle.font.text,
      fontStyle: "italic",
      color: "#6B7280", // faded black font
    },
  },
};
